import React, { useState } from 'react';
import useEmailNotifications from '../../hooks/useEmailNotifications';
import CAdminEmailNotificationTable from './CAdminEmailNotificationTable';
import IEmailNotification from '../../interfaces/IEmailNotification';
import CAdminEmailNotificationFilters from './CAdminEmailNotificationFilters';

const FAdminEmailNotifications = () => {
	const { data: emailNotifications } = useEmailNotifications();

	const [emailNotificationsFiltered, setEmailNotificationsFiltered] = useState<IEmailNotification[] | null>(null);

	return (
		<>
			<CAdminEmailNotificationFilters
				emailNotifications={emailNotifications ?? []}
				onChange={(values) => setEmailNotificationsFiltered(values)}
			/>
			<CAdminEmailNotificationTable emailNotifications={emailNotificationsFiltered ?? []} />
		</>
	);
};

export default FAdminEmailNotifications;
